/* eslint-disable no-barrel-files/no-barrel-files */

export { baseNodes, BasePlugins, createBaseConfig } from './config'
export type { LexicalEditorWrapperProps } from './LexicalEditorWrapper'
export { LexicalEditorWrapper } from './LexicalEditorWrapper'
export { lexicalEditorStyles, lexicalTheme } from './theme'
export {
  createRichTextContent,
  EditorMode,
  extractPlainText,
  sanitizeHtmlContent,
} from 'gecko-types'
export type { RichTextConfig, RichTextContent } from 'types/richText/types'
